import { Typography } from "antd";
import {
  DatabaseOutlined,
  CloudServerOutlined,
  SafetyCertificateOutlined,
  ApiOutlined,
  LineChartOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { FeatureCard } from "../../../../components";
import "./BusinessServices.scss";

const { Title, Text } = Typography;

const services = [
  {
    icon: <DatabaseOutlined />,
    title: "Advanced Data Management",
    description:
      "Secure, scalable storage for patient blacklist records with real-time synchronization across your organization.",
  },
  {
    icon: <SafetyCertificateOutlined />,
    title: "HIPAA Compliance",
    description:
      "Full compliance with healthcare regulations, ensuring data privacy and security.",
  },
  {
    icon: <ApiOutlined />,
    title: "REST API Integration",
    description:
      "Secure API access for organizations to integrate patient blacklist data into their existing systems.",
  },
  {
    icon: <CloudServerOutlined />,
    title: "Cloud Infrastructure",
    description:
      "Enterprise-grade cloud hosting with 99.9% uptime guarantee and automatic backups.",
  },
  {
    icon: <LineChartOutlined />,
    title: "Analytics & Insights",
    description:
      "Powerful analytics dashboard to track metrics and make data-driven decisions.",
  },
  {
    icon: <TeamOutlined />,
    title: "Multi-User Access",
    description:
      "Role-based permissions and unlimited users for your entire organization.",
  },
];

export default function BusinessServices({ token }) {
  return (
    <div className="businessServices">
      <div style={{ textAlign: "center", marginBottom: "32px" }}>
        <Title level={2} style={{ color: token?.colorPrimary, marginTop: 0 }}>
          Enterprise Solutions
        </Title>
        <Text className="businessServices__description">
          Everything your organization needs to streamline operations and
          enhance patient care
        </Text>
      </div>

      <div className="businessServices__grid">
        {services?.map((service, index) => (
          <FeatureCard
            key={index}
            feature={service}
            index={index}
            token={token}
          />
        ))}
      </div>
    </div>
  );
}
